import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import { connect } from 'react-redux'

import Hexapod from '../../../Assets/images/Create Actions/Hexapod.png'
import createStyle from './ActionsCreate.module.css'
import humanoid from '../../../Assets/images/ZingImage.png'
import inactiveBtnOne from '../../../Assets/images/Create Actions/Component 31 – 71.png'
import activeBtnOne from '../../../Assets/images/Create Actions/Component 31 – 88.png'
import inactivebtntwo from '../../../Assets/images/Create Actions/Component 31 – 72.png'
import activeBtnTwo from '../../../Assets/images/Create Actions/Component 31 – 89.png'
import inactiveBtnThree from '../../../Assets/images/Create Actions/Component 31 – 3.png'
import activeBtnthree from '../../../Assets/images/Create Actions/activecomponent 31 – 90.png'
import inactivebtnfour from '../../../Assets/images/Create Actions/Component 31 – 74.png'
import activeBtnfour from '../../../Assets/images/Create Actions/Component 31 – 91.png'
import inactiveBtnfive from '../../../Assets/images/Create Actions/Component 31 – 75.png'
import activeBtnfive from '../../../Assets/images/Create Actions/Component 31 – 92.png'
import inactiveBtnsix from '../../../Assets/images/Create Actions/Component 31 – 76.png'
import activeBtnsix from '../../../Assets/images/Create Actions/Component 31 – 93.png'
import inactiveBtnseven from '../../../Assets/images/Create Actions/Component 31 – 77.png'
import activeBtnseven from '../../../Assets/images/Create Actions/Component 31 – 94.png'
import inactivebtneight from '../../../Assets/images/Create Actions/Component 31 – 78.png'
import activeBtneight from '../../../Assets/images/Create Actions/Component 31 – 95.png'
import inactivebtnnine from '../../../Assets/images/Create Actions/Component 31 – 79.png'
import activeBtnnine from '../../../Assets/images/Create Actions/Component 31 – 96.png'
import inactivebtnten from '../../../Assets/images/Create Actions/Component 31 – 80.png'
import activeBtnten from '../../../Assets/images/Create Actions/Component 31 – 97.png'
import inactivebtneleven from '../../../Assets/images/Create Actions/Component 31 – 81.png'
import activeBtneleven from '../../../Assets/images/Create Actions/Component 31 – 98.png'
import inactivebtntweleve from '../../../Assets/images/Create Actions/Component 31 – 82.png'
import activeBtnTweleve from '../../../Assets/images/Create Actions/Component 31 – 99.png'
import inactiveBtnthirteen from '../../../Assets/images/Create Actions/Component 31 – 83.png'
import activeBtnThirteen from '../../../Assets/images/Create Actions/Component 31 – 100.png'
import inactiveBtnfourteen from '../../../Assets/images/Create Actions/Component 31 – 67.png'
import activeBtnfourteen from '../../../Assets/images/Create Actions/Component 31 – 84.png'
import inactiveBtnfifteen from '../../../Assets/images/Create Actions/Component 31 – 68.png'
import activeBtnfifteen from '../../../Assets/images/Create Actions/Component 31 – 85.png'
import inactiveBtnsixteen from '../../../Assets/images/Create Actions/Component 31 – 69.png'
import activeBtnsixteen from '../../../Assets/images/Create Actions/Component 31 – 86.png'
import inactiveBtnseventeen from '../../../Assets/images/Create Actions/Component 31 - 101.png'
import activeBtnseventeen from '../../../Assets/images/Create Actions/Component 31 - 103.png'
import inactiveBtneightteen from '../../../Assets/images/Create Actions/Component 31 - 102.png'
import activeBtneightteen from '../../../Assets/images/Create Actions/Component 31 - 104.png'
import inactiveBtnH from '../../../Assets/images/Create Actions/Component 31 – 70.png'
import activeBtnH from '../../../Assets/images/Create Actions/Component 31 – 87.png'
import backbutton from '../../../Assets/images/back@2x.png'
import nextbutton from '../../../Assets/images/next@2x.png'

import renderPrgImage from '../../../source/programImg'
import ProgramHeader from '../../ReusableComponents/Header/ProgramHeader'
import { readBytes, sendBytes } from '../../ReusableComponents/ByteTransfer'
import unicodeToChar from '../../../utils/unicodeToChar'
import SavePopUp from './SavePopUp'
import ViewActions from './ViewActions'
import {
    CREATEACTIONSTATE,
    DEFAULTSERVOVALUES,
    SINGLEACTIONSTATE,
    MINARRAYFORZINGACTION,
    MAXARRAYFORZINGACTION,
    MINARRAYFORHEXAPODACTION,
    MAXARRAYFORHEXAPODACTION,
} from './defaultData'
import SliderBox from '../../ReusableComponents/SliderBox/SliderBox'

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import ActionButton from './ActionButton'
import {
    actionConverter,
    decimalToMSBLSB,
    generateDeviceDataKey,
    MSBLSBToDecimal,
} from '../../ReusableComponents/ByteTransfer/utils'
import { Block } from '@material-ui/icons'
import { style } from '@material-ui/system'
import DialogModal from '../../ReusableComponents/DialogModal/DialogModal'
import ActionCreateHelp from './ActionsCreateHelp'
// import { generateDeviceDataKey } from '../../Humanoid/defaultData'
const connectedDevice = sessionStorage.getItem('connectedDevice')
let status = true
const addIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        fill="currentColor"
        className="bi bi-plus-circle-dotted"
        viewBox="0 0 16 16"
    >
        <path d="M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
    </svg>
)
const IMAGE = {
    HEXAPOD: Hexapod,
    HUMANOID: humanoid,
}

//
//    ACTIONS TO BYTE
//    The function acts like a adapter that converts the custom servo values into bytes
//    that can be readily sent to the humanoid
//
export const actionsToBytes = (
    actionsData,
    AGSlotId,
    mode,
    SingleAction,
    fileName
) => {
    console.log(actionsData, AGSlotId, mode, SingleAction)
    const actionGroupBytes = []
    const connectedDevice = sessionStorage.getItem('connectedDevice') || ''
    const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'

    const servoDataKey = generateDeviceDataKey(connectedDevice, deviceVersion)
    // Now each actionArr will look like this : ['T', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 'H']
    const actionArr = Array.from(
        { length: connectedDevice === 'Hexapod' ? 18 : 16 },
        (_, i) => i + 1
    )
    if (connectedDevice === 'Humanoid') {
        actionArr.push('H')
    }
    actionArr.splice(0, 0, 'T')

    // Prefix Flag for single action group only for v1 and v2
    if (
        ['1', '2'].includes(deviceVersion[0]) &&
        ['Humanoid', 'Hexapod'].includes(connectedDevice)
    ) {
        let fLength
        let fNameAsci = []
        if (fileName) {
            // fileName = fileName + '.BIN'
            fLength = fileName.length

            fNameAsci = fileName.split('').map((char) => char.charCodeAt(0))
            console.log('KKKKKKKKKKKK', fNameAsci)
        }
        actionGroupBytes.push(
            'G'.charCodeAt(0),
            'R'.charCodeAt(0)
            // 123,
            // 125,
            // 'N'.charCodeAt(0),
            // 123
        )
        if (fileName) {
            actionGroupBytes.push(fLength, ...fNameAsci)
        } else {
            actionGroupBytes.push(0)
        }
    }

    // Looping over all actions
    // Exporting all the actions in the action group
    if (mode == 'ALLACTIONS') {
        if (
            ['1', '2'].includes(deviceVersion[0]) &&
            ['Humanoid', 'Hexapod'].includes(connectedDevice)
        ) {
            let MSBLSBRowLength = decimalToMSBLSB(actionsData.allActions.length)
            actionGroupBytes.push(
                MSBLSBRowLength[0],
                MSBLSBRowLength[1]
                // 125
                // 'P'.charCodeAt(0)
            )
        }
        actionsData.allActions.map((action) => {
            // Prefix Flag for single action group
            if (
                !(
                    ['1', '2'].includes(deviceVersion[0]) &&
                    ['Humanoid', 'Hexapod'].includes(connectedDevice)
                )
            ) {
                actionGroupBytes.push(
                    'A'.charCodeAt(0),
                    'G'.charCodeAt(0),
                    AGSlotId,
                    actionsData.allActions.length
                )
            }
            // else {
            //     actionGroupBytes.push('P'.charCodeAt(0), 123)
            // }

            // Filling each servo value for particular action
            actionArr.map((key) => {
                let MSBLSB
                if (key !== 'H') {
                    if (action.data[key].isEnabled)
                        MSBLSB = decimalToMSBLSB(action.data[key].value)
                    else
                        MSBLSB = decimalToMSBLSB(
                            DEFAULTSERVOVALUES[
                                servoDataKey
                                // `${connectedDevice.toUpperCase()}`
                            ][key]
                        )
                    actionGroupBytes.push(MSBLSB[0], MSBLSB[1])
                } else {
                    if (
                        !(
                            ['1', '2'].includes(deviceVersion[0]) &&
                            ['Humanoid', 'Hexapod'].includes(connectedDevice)
                        )
                    ) {
                        if (action.data[key].isEnabled)
                            actionGroupBytes.push(action.data[key].speed)
                        else actionGroupBytes.push(10)

                        // if (action.data[key].isEnabled)
                        //     actionGroupBytes.push(action.data[key].value)
                        // else actionGroupBytes.push(90)
                    }

                    if (action.data[key].isEnabled)
                        actionGroupBytes.push(action.data[key].value)
                    else actionGroupBytes.push(90)
                }
            })

            // Suffix Flag for single action group
            if (
                ['1', '2'].includes(deviceVersion[0]) &&
                ['Humanoid', 'Hexapod'].includes(connectedDevice)
            ) {
                // actionGroupBytes.push(125) //'E'.charCodeAt(0), 'R'.charCodeAt(0)
            } else {
                actionGroupBytes.push(
                    'X'.charCodeAt(0),
                    'Y'.charCodeAt(0),
                    'Z'.charCodeAt(0)
                )
            }
        })
        if (
            ['1', '2'].includes(deviceVersion[0]) &&
            ['Humanoid', 'Hexapod'].includes(connectedDevice)
        ) {
            actionGroupBytes.push('E'.charCodeAt(0), 'R'.charCodeAt(0))
        }
        // Exporting only one action in the entire action group
    } else if (mode == 'ONLYTHISACTION') {
        // Prefix Flag for single action group
        if (
            ['1', '2'].includes(deviceVersion[0]) &&
            ['Humanoid', 'Hexapod'].includes(connectedDevice)
        ) {
            let MSBLSBRowLength = decimalToMSBLSB(1)
            actionGroupBytes.push(
                MSBLSBRowLength[0],
                MSBLSBRowLength[1]
                // 125,
                // 'P'.charCodeAt(0),
                // 123
            )
        } else {
            actionGroupBytes.push(
                'A'.charCodeAt(0),
                'G'.charCodeAt(0),
                AGSlotId,
                0
            )
        }
        const action = SingleAction

        actionArr.map((key) => {
            let MSBLSB
            if (key !== 'H') {
                if (action.data[key].isEnabled) {
                    MSBLSB = decimalToMSBLSB(action.data[key].value)
                } else {
                    MSBLSB = decimalToMSBLSB(
                        DEFAULTSERVOVALUES[servoDataKey][key]
                    )
                }
                actionGroupBytes.push(MSBLSB[0], MSBLSB[1])
            } else {
                if (
                    !(
                        ['1', '2'].includes(deviceVersion[0]) &&
                        ['Humanoid', 'Hexapod'].includes(connectedDevice)
                    )
                ) {
                    if (action.data[key].isEnabled)
                        actionGroupBytes.push(action.data[key].speed)
                    else actionGroupBytes.push(10)

                    if (action.data[key].isEnabled)
                        actionGroupBytes.push(action.data[key].value)
                    else actionGroupBytes.push(90)
                }

                if (action.data[key].isEnabled)
                    actionGroupBytes.push(action.data[key].value)
                else actionGroupBytes.push(90)
            }
        })

        // Suffix Flag for single action group
        if (
            ['1', '2'].includes(deviceVersion[0]) &&
            ['Humanoid', 'Hexapod'].includes(connectedDevice)
        ) {
            actionGroupBytes.push('E'.charCodeAt(0), 'R'.charCodeAt(0))
        } else {
            actionGroupBytes.push(
                'X'.charCodeAt(0),
                'Y'.charCodeAt(0),
                'Z'.charCodeAt(0)
            )
        }
    }
    return actionGroupBytes
}

function CreateAction({ webSerial, worker }) {
    const history = useHistory()
    const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
    const isZingVersion12 =
        ['1', '2'].includes(
            (sessionStorage.getItem('deviceVersion') || '0.0.0')[0]
        ) && ['Humanoid'].includes(sessionStorage.getItem('connectedDevice'))

    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const [createActionState, setCreateActionState] =
        useState(CREATEACTIONSTATE)
    const [selectedAction, setSelectedAction] = useState(0)
    const [showPrimaryButtons, setShowPrimaryButtons] = useState(false)
    const [hoverActionId, setHoverActionId] = useState(0)
    const [display, setDisplay] = useState('block')
    const [filePopup, setFilePopUp] = useState(false)
    const [retrieveActions, setRetrieveActions] = useState(false)
    const [showDeviceConnectModal, setShowDeviceConnectModal] = useState(false)
    const [slideDirection, setSlideDirection] = useState(
        sessionStorage.getItem('slideDirection')
    )
    const [showHelpScreen, setShowHelpScreen] = useState(false)

    const COMMONBUTTONS = [
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-one`]
            }`}
            src={
                createActionState.commonActionState[1].isSelected
                    ? activeBtnOne
                    : inactiveBtnOne
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-two`]
            }`}
            src={
                createActionState.commonActionState[2].isSelected
                    ? activeBtnTwo
                    : inactivebtntwo
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-three`]
            }`}
            src={
                createActionState.commonActionState[3].isSelected
                    ? activeBtnthree
                    : inactiveBtnThree
            }
        />,

        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-four`]
            }`}
            src={
                createActionState.commonActionState[4].isSelected
                    ? activeBtnfour
                    : inactivebtnfour
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-five`]
            }`}
            src={
                createActionState.commonActionState[5].isSelected
                    ? activeBtnfive
                    : inactiveBtnfive
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-six`]
            }`}
            src={
                createActionState.commonActionState[6].isSelected
                    ? activeBtnsix
                    : inactiveBtnsix
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-seven`]
            }`}
            src={
                createActionState.commonActionState[7].isSelected
                    ? activeBtnseven
                    : inactiveBtnseven
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-eight`]
            }`}
            src={
                createActionState.commonActionState[8].isSelected
                    ? activeBtneight
                    : inactivebtneight
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-nine`]
            }`}
            src={
                createActionState.commonActionState[9].isSelected
                    ? activeBtnnine
                    : inactivebtnnine
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-ten`]
            }`}
            src={
                createActionState.commonActionState[10].isSelected
                    ? activeBtnten
                    : inactivebtnten
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-eleven`]
            }`}
            src={
                createActionState.commonActionState[11].isSelected
                    ? activeBtneleven
                    : inactivebtneleven
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-tweleve`]
            }`}
            src={
                createActionState.commonActionState[12].isSelected
                    ? activeBtnTweleve
                    : inactivebtntweleve
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-thirteen`]
            }`}
            src={
                createActionState.commonActionState[13].isSelected
                    ? activeBtnThirteen
                    : inactiveBtnthirteen
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-fourteen`]
            }`}
            src={
                createActionState.commonActionState[14].isSelected
                    ? activeBtnfourteen
                    : inactiveBtnfourteen
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-fifteen`]
            }`}
            src={
                createActionState.commonActionState[15].isSelected
                    ? activeBtnfifteen
                    : inactiveBtnfifteen
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[`sc-btn-${connectedDevice.toLowerCase()}-sixteen`]
            }`}
            src={
                createActionState.commonActionState[16].isSelected
                    ? activeBtnsixteen
                    : inactiveBtnsixteen
            }
        />,
    ]
    const DEVICEBUTTONS = {
        HUMANOID: COMMONBUTTONS,
        HEXAPOD: COMMONBUTTONS,
        KLAW: [COMMONBUTTONS.slice(0, 5)],
    }

    const handleClickHelpBtn = () => {
        setShowHelpScreen(true)
    }
    const closeHelpScreen = () => {
        setShowHelpScreen(false)
    }
    // loading existing createActionState or loading a new one
    useEffect(() => {
        const existingState = JSON.parse(
            sessionStorage.getItem('createActionState')
        )
        if (existingState) setCreateActionState(existingState)

        // sending bytes to stop standby actions
        // sendBytes(
        //     ['S'.charCodeAt(0), 'A'.charCodeAt(0), 'E'.charCodeAt(0)],
        //     webSerial.port
        // )
    }, [])

    // Saving each change directly to the sessionStorage
    useEffect(() => {
        sessionStorage.setItem(
            'createActionState',
            JSON.stringify(createActionState)
        )
    })

    const [lastSentBytesTime, setLastSentBytesTime] = useState(Date.now())

    // This function sends servo bytes instantly to get the live feedback
    const liveServoFeedback = (servoId, value) => {
        if (retrieveActions) return
        if (display === 'none') return
        if (servoId === 'T') return

        const servoFeedbackBytes = []
        if (servoId === 'H' || servoId === 'Hservo') {
            servoFeedbackBytes.push('S'.charCodeAt(0), 'M'.charCodeAt(0), 17)
        } else {
            servoFeedbackBytes.push(
                'S'.charCodeAt(0),
                'M'.charCodeAt(0),
                parseInt(servoId)
            )
        }

        let MSBLSB = decimalToMSBLSB(value)
        servoFeedbackBytes.push(MSBLSB[0], MSBLSB[1])

        // sends bytes every 100ms
        // Zing doesn't respond when sent faster than 100ms
        const now = Date.now()
        if (now - lastSentBytesTime < 100) return
        console.log(servoFeedbackBytes)
        // if (deviceVersion?.startsWith('2')) {
        worker.postMessage({
            type: 'writeArray',
            value: servoFeedbackBytes,
        })
        // } else {
        //     sendBytes(servoFeedbackBytes, webSerial.port)
        // }
        setLastSentBytesTime(now)
    }

    // changes to determine Min and Max value for Zing motors
    const handleMinMax = (servoId, tag, device) => {
        if (device === 'ZING') {
            if (tag === 'MIN') {
                return MINARRAYFORZINGACTION[servoId - 1]
            } else {
                return MAXARRAYFORZINGACTION[servoId - 1]
            }
        } //We can add more devices here
        if (device === 'HEXAPOD') {
            if (tag === 'MIN') {
                return MINARRAYFORHEXAPODACTION[servoId - 1]
            } else {
                return MAXARRAYFORHEXAPODACTION[servoId - 1]
            }
        }
    }

    // changes servo values
    const handleSliderChange = (servoId, value) => {
        sessionStorage.setItem('isSave', JSON.stringify(false))
        const newCreateActionState = { ...createActionState }
        newCreateActionState.allActions = createActionState.allActions.map(
            (action, index) => {
                if (index != selectedAction) return action
                if (['Hspeed', 'Hservo'].includes(servoId)) {
                    if (servoId === 'Hspeed') {
                        action.data['H'].speed = value
                        return action
                    } else {
                        action.data['H'].value = value
                        return action
                    }
                } else {
                    action.data[servoId].value = value
                    return action
                }
            }
        )
        setCreateActionState(newCreateActionState)
        liveServoFeedback(servoId, value)
    }

    // Enables/disables servos
    const handleSliderBtnClick = (servoId) => {
        sessionStorage.setItem('isSave', JSON.stringify(false))
        if (['Hspeed', 'Hservo'].includes(servoId)) servoId = 'H'
        const newCreateActionState = { ...createActionState }
        newCreateActionState.allActions = createActionState.allActions.map(
            (action, index) => {
                if (index != selectedAction) return action
                action.data[servoId].isEnabled = !action.data[servoId].isEnabled
                if (action.data[servoId].isEnabled) {
                    liveServoFeedback(servoId, action.data[servoId].value)
                }
                return action
            }
        )
        setCreateActionState(newCreateActionState)
    }

    // Changes the focus of currently selected action amoung the action group.
    const handleSelectAction = (id) => {
        setSelectedAction(id)
        setShowPrimaryButtons(true)
    }

    // shows the delete and copy option when hovered over any of the action button
    const handleToggleButtons = (id, condition) => {
        // if (id !== selectedAction) return
        setHoverActionId(id)
        setShowPrimaryButtons(condition)
    }

    const addNewAction = () => {
        sessionStorage.setItem('isSave', JSON.stringify(false))
        const newCreateActionState = { ...createActionState }
        //edit here to get more actions
        newCreateActionState.allActions.push({
            id: Math.random().toString(16).slice(2, 6),
            data: JSON.parse(JSON.stringify(SINGLEACTIONSTATE)),
        })
        setCreateActionState(newCreateActionState)
        setTimeout(() => {
            const lastActionId = newCreateActionState.allActions.length
            const element = document.getElementById(`actionBtn-${lastActionId}`)
            element.scrollIntoView()
        }, 100)
    }
    // console.log('SINGLEACTIONSTATE', SINGLEACTIONSTATE)
    const deleteAction = (event, idToDel) => {
        event.stopPropagation()
        sessionStorage.setItem('isSave', JSON.stringify(false))
        if (createActionState.allActions.length == 1) return
        if (selectedAction == createActionState.allActions.length - 1) {
            if (createActionState.allActions.length == 2) {
                setSelectedAction(0)
            } else {
                setSelectedAction(Math.abs(idToDel - 1))
            }
        }
        const newCreateActionState = { ...createActionState }
        newCreateActionState.allActions.splice(idToDel, 1)
        setCreateActionState(newCreateActionState)
    }

    const copyAction = (event, idToCopy) => {
        event.stopPropagation()
        sessionStorage.setItem('isSave', JSON.stringify(false))
        const newCreateActionState = { ...createActionState }
        newCreateActionState.allActions.push({
            id: Math.random().toString(16).slice(2, 6),
            data: JSON.parse(
                JSON.stringify(createActionState.allActions[idToCopy].data)
            ),
        })
        setCreateActionState(newCreateActionState)
        setSelectedAction(newCreateActionState.allActions.length - 1)
    }

    // Sends the action bytes of only the selected action
    const handlePlayAction = async () => {
        if (!webSerial.isConnected) {
            setShowDeviceConnectModal(true)
            return
        }
        setDisplay('none')
        const actionsData = JSON.parse(
            sessionStorage.getItem('createActionState')
        )

        const data = await actionsToBytes(
            actionsData,
            0,
            'ONLYTHISACTION',
            createActionState.allActions[selectedAction]
        )
        console.log('action bytes', data)
        // if (sessionStorage.getItem('deviceVersion')?.startsWith('2')) {
        // sessionStorage.setItem('setHandlePlayAction_Start', 'true')
        worker.postMessage({
            type: 'writeArray',
            value: data,
        })
        sessionStorage.setItem('sendDataAsPacket', 'true')
        try {
            let replyOK = await Promise.race([
                checkOk(),
                timeoutPromise(10000), //
            ])
        } catch (e) {
            setDisplay('block')
        }
        // } else {
        //     await sendBytes(data, webSerial.port)
        //     if (await readBytes(webSerial.port, 'OK')) setDisplay('block')
        // }
    }

    // Sends the action bytes of the entire action group
    const handlePlayActionGroup = async () => {
        if (!webSerial.isConnected) {
            setShowDeviceConnectModal(true)
            return
        }
        if (display !== 'none') {
            setDisplay('none')
            const actionsData = JSON.parse(
                sessionStorage.getItem('createActionState')
            )
            const data = actionsToBytes(actionsData, 0, 'ALLACTIONS')
            if (['1', '2'].includes(deviceVersion[0])) {
                // sendDataAsPackets_zingV2(data, 42, webSerial.port)
                console.log('datas', data)
                worker.postMessage({
                    type: 'writeArray',
                    value: data,
                })
                sessionStorage.setItem('sendDataAsPacket', 'true')
                try {
                    let replyOK = await Promise.race([
                        checkOk(),
                        timeoutPromise(20000), //
                    ])
                } catch (e) {
                    setDisplay('block')
                }
            } else {
                let size = 43
                // if (
                //     deviceVersion?.startsWith('1') &&
                //     ['Humanoid'].includes(connectedDevice)
                // ) {
                //     size = data.length
                // } else {
                //     size = 43
                // }
                if (await sendDataAsPackets(data, size, webSerial.port)) {
                    window.location.reload()
                }
            }
        } else {
            if (['1', '2'].includes(deviceVersion[0])) {
                setDisplay('block')
                worker.postMessage({
                    type: 'writeArray',
                    value: ['R'.charCodeAt(0), 'a'.charCodeAt(0)],
                })

                sessionStorage.setItem('sendDataAsPacket', 'true')
                try {
                    let replyOK = await Promise.race([
                        checkOk(),
                        timeoutPromise(1000), //
                    ])
                } catch (e) {
                    setDisplay('block')
                }
            }
        }
    }

    // This function splits the data into packets of custom size
    // and also sends them at the given interval
    const timeoutPromise = (ms) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                console.log('HHHHHHHHHH Time Out')
                reject(new Error('Timeout exceeded'))
            }, ms)
        })
    }

    const checkOk = async () => {
        return new Promise(async (resolve, reject) => {
            while (true) {
                if (!JSON.parse(sessionStorage.getItem('sendDataAsPacket'))) {
                    return resolve()
                }

                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })
            }
        })
    }

    const sendDataAsPackets = async (data, size, port) => {
        let count = 0
        let actionRowLength = JSON.parse(
            sessionStorage.getItem('createActionState')
        ).allActions.length
        while (data.length !== 0) {
            if (status) {
                let dataToBeSentNow
                // if (
                //     deviceVersion?.startsWith('1') &&
                //     ['Humanoid'].includes(connectedDevice) &&
                //     count === 0
                // ) {
                //     dataToBeSentNow = data.splice(0, 49)
                // } else if (
                //     deviceVersion?.startsWith('1') &&
                //     ['Humanoid'].includes(connectedDevice) &&
                //     count === actionRowLength - 1
                // ) {
                //     dataToBeSentNow = data.splice(0, 40)
                // } else {
                dataToBeSentNow = data.splice(0, size)
                // }

                sendBytes(dataToBeSentNow, port)
                count += 1
                status = false
                let replyOK
                try {
                    // const resultPromise = (replyOK = await readBytes(
                    //     port,
                    //     'OK'
                    // ))
                    try {
                        // if (sessionStorage.getItem('zingVersion')[0] == '2') {
                        replyOK = await Promise.race([
                            readBytes(port, 'OK'),
                            timeoutPromise(5000),
                        ])
                    } catch {
                        return true
                    }
                    console.log(replyOK, 'gsk replyOK')
                    if (replyOK == undefined) return true

                    if (replyOK) {
                        status = true
                    }
                } catch (error) {
                    console.log('errrr', error)
                    window.location.reload()
                }
            }
            if (
                count ===
                    JSON.parse(sessionStorage.getItem('createActionState'))
                        .allActions.length ||
                deviceVersion?.startsWith('1')
            ) {
                setDisplay('block')
                break
            }
        }
    }

    const backButton = () => {
        setSlideDirection(true)
        sessionStorage.setItem('slideDirection', true)
        saverecoveryData()
        if (display == 'none') return

        // sending bytes to resume standby actions
        if (sessionStorage.getItem('deviceVersion')?.startsWith('0.1')) {
            worker.postMessage({
                type: 'writeArray',
                value: [
                    'S'.charCodeAt(0),
                    'A'.charCodeAt(0),
                    'S'.charCodeAt(0),
                ],
            })
        }

        history.push('/code/project/action/select')
    }

    // Reorders the action buttons based on drag and drop
    function dragEndHandler({ source, destination }) {
        // dropped outside the list
        if (!destination) {
            return
        }

        // dropped on the SAME list
        const newCreateActionState = { ...createActionState }
        sessionStorage.setItem('isSave', JSON.stringify(false))
        const newList = newCreateActionState.allActions
        const [removed] = newList.splice(source.index, 1)
        newList.splice(destination.index, 0, removed)

        setCreateActionState(newCreateActionState)
        setSelectedAction(destination.index)
    }

    // its save the createActionState data in local storage
    const saverecoveryData = () => {
        let newRecoveryData =
            JSON.parse(localStorage.getItem('recoveryData')) || {}
        let newCreateActionState = JSON.parse(
            sessionStorage.getItem('createActionState')
        )

        //create the recoveryData object
        function addData(baseType, connectedDevice, deviceVersion, data) {
            if (!newRecoveryData[baseType]) {
                newRecoveryData[baseType] = {}
            }
            if (!newRecoveryData[baseType][connectedDevice]) {
                newRecoveryData[baseType][connectedDevice] = {}
            }
            if (!newRecoveryData[baseType][connectedDevice][deviceVersion]) {
                newRecoveryData[baseType][connectedDevice][deviceVersion] = {}
            }
            newRecoveryData[baseType][connectedDevice][
                deviceVersion
            ].createActionState = data
        }

        addData(
            'actionBase',
            connectedDevice,
            deviceVersion,
            newCreateActionState
        )

        localStorage.setItem('recoveryData', JSON.stringify(newRecoveryData))
    }

    useEffect(() => {
        //read data from serial worker
        const messageHandler = (e) => {
            if (
                e.data.type === 'read' &&
                (e.data.value.includes('GROK') ||
                    e.data.value.includes('RDONE'))
            ) {
                setDisplay('block')
                sessionStorage.setItem('sendDataAsPacket', 'false')
            }
        }

        //if user close the window its save the createActionState data in local storage
        const handleBeforeUnload = (e) => {
            saverecoveryData()
        }
        worker.addEventListener('message', messageHandler)
        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => {
            worker.removeEventListener('message', messageHandler)
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [])
    useEffect(() => {
        //read data from serial worker
        const servoRead = (e) => {
            if (e.data.type === 'servoRead') {
                const newCreateActionState = { ...createActionState }
                for (let i = 0; i < e.data.value.length; i += 2) {
                    if (
                        newCreateActionState.allActions[selectedAction].data[
                            (i + 2) / 2
                        ].isEnabled
                    )
                        newCreateActionState.allActions[selectedAction].data[
                            (i + 2) / 2
                        ].value = (e.data.value[i + 1] << 8) | e.data.value[i]
                }
                setCreateActionState({ ...newCreateActionState })
                setDisplay('block')
            }
        }
        worker.addEventListener('message', servoRead)
        return () => worker.removeEventListener('message', servoRead)
    }, [createActionState])
    return (
        <div className={createStyle['create-Container']}>
            <SavePopUp showPopUp={filePopup} setFilePopUp={setFilePopUp} />
            {/*----- open the model to show if device is not connect ------*/}
            <DialogModal
                show={showDeviceConnectModal}
                text="Please connect the device."
                showCloseBtn={true}
                handleDialogModalClose={() => setShowDeviceConnectModal(false)}
            />
            {/*----- open the model to show the fetch file from zing ------*/}
            <ViewActions
                viewPopUp={retrieveActions}
                setViewPopUp={setRetrieveActions}
                setCreateActionState={setCreateActionState}
                setSelectedAction={setSelectedAction}
            />
            <ProgramHeader
                data={{
                    options: [
                        'Select',
                        'Create',
                        ...(isZingVersion12 || connectedDevice === 'Hexapod'
                            ? ''
                            : ['Save']),
                        '',
                    ],
                    selected:
                        isZingVersion12 || connectedDevice === 'Hexapod'
                            ? 2
                            : 1,
                }}
                viewActions={
                    isZingVersion12 || connectedDevice === 'Hexapod'
                        ? true
                        : false
                }
                actionsList={setRetrieveActions}
                showSave={
                    isZingVersion12 || connectedDevice === 'Hexapod'
                        ? false
                        : true
                }
                handleSave={() => {
                    history.push('/code/project/action/save')
                }}
                showHelp={true}
                handleHelp={handleClickHelpBtn}
            />

            {/* call the help screen */}
            {showHelpScreen && (
                <ActionCreateHelp closeModal={closeHelpScreen} />
            )}

            <div
                className={`${
                    slideDirection === 'true' ? 'slide-right' : 'slide-left'
                }`}
                style={{ height: '78vh' }}
            >
                <div className={createStyle['create-body-container']}>
                    <div className={createStyle['action-sidebar']}>
                        <div
                            className={createStyle['action-sidebar-scrollZone']}
                        >
                            <DragDropContext onDragEnd={dragEndHandler}>
                                <Droppable droppableId="actionCol">
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            style={{
                                                height: '100%',
                                                overflowY: 'scroll',
                                            }}
                                        >
                                            {createActionState.allActions.map(
                                                (action, index) => (
                                                    <Draggable
                                                        draggableId={action.id}
                                                        index={index}
                                                        key={action.id}
                                                    >
                                                        {(
                                                            provided,
                                                            snapshot
                                                        ) => (
                                                            <div
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                ref={
                                                                    provided.innerRef
                                                                }
                                                                id={`actionBtn-${
                                                                    index + 1
                                                                }`}
                                                            >
                                                                <ActionButton
                                                                    selectedAction={
                                                                        selectedAction
                                                                    }
                                                                    hoverActionId={
                                                                        hoverActionId
                                                                    }
                                                                    showPrimaryButtons={
                                                                        showPrimaryButtons
                                                                    }
                                                                    index={
                                                                        index
                                                                    }
                                                                    action={
                                                                        action
                                                                    }
                                                                    handleSelectAction={
                                                                        handleSelectAction
                                                                    }
                                                                    handleToggleButtons={
                                                                        handleToggleButtons
                                                                    }
                                                                    deleteAction={
                                                                        deleteAction
                                                                    }
                                                                    copyAction={
                                                                        copyAction
                                                                    }
                                                                    handlePlayAction={
                                                                        handlePlayAction
                                                                    }
                                                                    display={
                                                                        display
                                                                    }
                                                                />
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                )
                                            )}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </div>
                        <button
                            className={createStyle['addBtn']}
                            onClick={addNewAction}
                        >
                            {addIcon}
                        </button>
                    </div>

                    <div className={createStyle['action-card']}>
                        <>
                            <SliderBox
                                key={'T'}
                                id={'T'}
                                btnText="Time"
                                sliderText="milliseconds"
                                value={
                                    createActionState.allActions[selectedAction]
                                        .data['T'].value
                                }
                                min={0}
                                max={5000}
                                handleSliderChange={handleSliderChange}
                                handleClick={handleSliderBtnClick}
                                isEnabled={
                                    createActionState.allActions[selectedAction]
                                        .data['T'].isEnabled
                                }
                                type="single"
                            />

                            {Object.entries(
                                createActionState.allActions[selectedAction]
                                    .data
                            ).map((servoId) => (
                                <>
                                    {isZingVersion12 &&
                                        createActionState.commonActionState[
                                            servoId[0]
                                        ].isSelected &&
                                        servoId[0] == 'H' && (
                                            <>
                                                {/* {' '}
                                                <SliderBox
                                                    key={servoId[0]}
                                                    id={`${servoId[0]}speed`}
                                                    btnText={`Head Speed`}
                                                    sliderText="Value"
                                                    value={
                                                        createActionState
                                                            .allActions[
                                                            selectedAction
                                                        ].data[servoId[0]].speed
                                                    }
                                                    min={0}
                                                    max={50}
                                                    handleSliderChange={
                                                        handleSliderChange
                                                    }
                                                    handleClick={
                                                        handleSliderBtnClick
                                                    }
                                                    isEnabled={
                                                        createActionState
                                                            .allActions[
                                                            selectedAction
                                                        ].data[servoId[0]]
                                                            .isEnabled
                                                    }
                                                    type="single"
                                                />{' '} */}
                                                <SliderBox
                                                    isDisabledAction={
                                                        display !== 'block'
                                                    }
                                                    key={servoId[0]}
                                                    id={`${servoId[0]}servo`}
                                                    btnText={`Head Servo`}
                                                    sliderText="Value"
                                                    value={
                                                        createActionState
                                                            .allActions[
                                                            selectedAction
                                                        ].data[servoId[0]].value
                                                    }
                                                    min={0}
                                                    max={180}
                                                    handleSliderChange={
                                                        handleSliderChange
                                                    }
                                                    handleClick={
                                                        handleSliderBtnClick
                                                    }
                                                    isEnabled={
                                                        createActionState
                                                            .allActions[
                                                            selectedAction
                                                        ].data[servoId[0]]
                                                            .isEnabled
                                                    }
                                                    type="single"
                                                />
                                            </>
                                        )}
                                    {createActionState.commonActionState[
                                        servoId[0]
                                    ].isSelected &&
                                        servoId[0] !== 'T' &&
                                        servoId[0] !== 'H' && (
                                            <SliderBox
                                                isDisabledAction={
                                                    display !== 'block'
                                                }
                                                // isDisabledAction={true}
                                                key={servoId[0]}
                                                id={servoId[0]}
                                                btnText={`Servo Motor ${servoId[0]}`}
                                                sliderText="Value"
                                                value={
                                                    createActionState
                                                        .allActions[
                                                        selectedAction
                                                    ].data[servoId[0]].value
                                                }
                                                min={
                                                    connectedDevice ===
                                                    'Hexapod'
                                                        ? handleMinMax(
                                                              servoId[0],
                                                              'MIN',
                                                              'HEXAPOD'
                                                          )
                                                        : isZingVersion12
                                                        ? handleMinMax(
                                                              servoId[0],
                                                              'MIN',
                                                              'ZING'
                                                          )
                                                        : 0
                                                }
                                                max={
                                                    connectedDevice ===
                                                    'Hexapod'
                                                        ? handleMinMax(
                                                              servoId[0],
                                                              'MAX',
                                                              'HEXAPOD'
                                                          )
                                                        : isZingVersion12
                                                        ? handleMinMax(
                                                              servoId[0],
                                                              'MAX',
                                                              'ZING'
                                                          )
                                                        : 1000
                                                }
                                                handleSliderChange={
                                                    handleSliderChange
                                                }
                                                handleClick={
                                                    handleSliderBtnClick
                                                }
                                                isEnabled={
                                                    createActionState
                                                        .allActions[
                                                        selectedAction
                                                    ].data[servoId[0]].isEnabled
                                                }
                                                type="single"
                                            />
                                        )}
                                </>
                            ))}
                        </>
                    </div>

                    <div
                        className={
                            createStyle[
                                `create-${connectedDevice.toLowerCase()}`
                            ]
                        }
                        style={{
                            backgroundImage: `url(${
                                IMAGE[connectedDevice.toUpperCase()]
                            })`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                        }}
                    >
                        {/* <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-one']}`}
                            src={
                                createActionState.commonActionState[1]
                                    .isSelected
                                    ? activeBtnOne
                                    : inactiveBtnOne
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-two']}`}
                            src={
                                createActionState.commonActionState[2]
                                    .isSelected
                                    ? activeBtnTwo
                                    : inactivebtntwo
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-three']}`}
                            src={
                                createActionState.commonActionState[3]
                                    .isSelected
                                    ? activeBtnthree
                                    : inactiveBtnThree
                            }
                        />

                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-four']}`}
                            src={
                                createActionState.commonActionState[4]
                                    .isSelected
                                    ? activeBtnfour
                                    : inactivebtnfour
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-five']}`}
                            src={
                                createActionState.commonActionState[5]
                                    .isSelected
                                    ? activeBtnfive
                                    : inactiveBtnfive
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-six']}`}
                            src={
                                createActionState.commonActionState[6]
                                    .isSelected
                                    ? activeBtnsix
                                    : inactiveBtnsix
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-seven']}`}
                            src={
                                createActionState.commonActionState[7]
                                    .isSelected
                                    ? activeBtnseven
                                    : inactiveBtnseven
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-eight']}`}
                            src={
                                createActionState.commonActionState[8]
                                    .isSelected
                                    ? activeBtneight
                                    : inactivebtneight
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-nine']}`}
                            src={
                                createActionState.commonActionState[9]
                                    .isSelected
                                    ? activeBtnnine
                                    : inactivebtnnine
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-ten']}`}
                            src={
                                createActionState.commonActionState[10]
                                    .isSelected
                                    ? activeBtnten
                                    : inactivebtnten
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-eleven']}`}
                            src={
                                createActionState.commonActionState[11]
                                    .isSelected
                                    ? activeBtneleven
                                    : inactivebtneleven
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-tweleve']}`}
                            src={
                                createActionState.commonActionState[12]
                                    .isSelected
                                    ? activeBtnTweleve
                                    : inactivebtntweleve
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-thirteen']}`}
                            src={
                                createActionState.commonActionState[13]
                                    .isSelected
                                    ? activeBtnThirteen
                                    : inactiveBtnthirteen
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-fourteen']}`}
                            src={
                                createActionState.commonActionState[14]
                                    .isSelected
                                    ? activeBtnfourteen
                                    : inactiveBtnfourteen
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-fifteen']}`}
                            src={
                                createActionState.commonActionState[15]
                                    .isSelected
                                    ? activeBtnfifteen
                                    : inactiveBtnfifteen
                            }
                        />
                        <img
                            className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-sixteen']}`}
                            src={
                                createActionState.commonActionState[16]
                                    .isSelected
                                    ? activeBtnsixteen
                                    : inactiveBtnsixteen
                            }
                        /> */}
                        {DEVICEBUTTONS[`${connectedDevice.toUpperCase()}`]}
                        {/* no clue */}
                        {isZingVersion12 && (
                            <img
                                className={`${createStyle['sc-toggle-button']} ${createStyle['sc-btn-H']}`}
                                src={
                                    createActionState.commonActionState['H']
                                        .isSelected
                                        ? activeBtnH
                                        : inactiveBtnH
                                }
                            />
                        )}
                        {connectedDevice === 'Hexapod' && (
                            <>
                                <img
                                    className={`${
                                        createStyle['sc-toggle-button']
                                    } ${
                                        createStyle[
                                            `sc-btn-${connectedDevice.toLowerCase()}-seventeen`
                                        ]
                                    }`}
                                    src={
                                        createActionState.commonActionState[17]
                                            .isSelected
                                            ? activeBtnseventeen
                                            : inactiveBtnseventeen
                                    }
                                />
                                <img
                                    className={`${
                                        createStyle['sc-toggle-button']
                                    } ${
                                        createStyle[
                                            `sc-btn-${connectedDevice.toLowerCase()}-eighteen`
                                        ]
                                    }`}
                                    src={
                                        createActionState.commonActionState[18]
                                            .isSelected
                                            ? activeBtneightteen
                                            : inactiveBtneightteen
                                    }
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>

            <div style={{ height: '10vh' }}>
                <img
                    className={createStyle['create-backbutton']}
                    style={{
                        cursor: display == 'none' ? 'not-allowed' : 'pointer',
                    }}
                    src={backbutton}
                    onClick={backButton}
                />

                <img
                    className={createStyle['create-nextbutton']}
                    style={{
                        bottom:
                            isZingVersion12 || connectedDevice === 'Hexapod'
                                ? '3%'
                                : null,
                        cursor: display == 'none' ? 'not-allowed' : 'pointer',
                    }}
                    src={
                        isZingVersion12 || connectedDevice === 'Hexapod'
                            ? renderPrgImage('saveBtn')
                            : nextbutton
                    }
                    onClick={() => {
                        setSlideDirection(false)
                        sessionStorage.setItem('slideDirection', false)
                        if (display == 'none') return
                        if (isZingVersion12 || connectedDevice === 'Hexapod') {
                            setFilePopUp(true)
                        } else {
                            history.push('/code/project/action/upload')
                        }
                    }}
                />
                <span
                    className={`${createStyle.tooltip} ${createStyle.savbtn}`}
                    style={{
                        position: 'absolute',
                        right: '0%',
                        bottom: '9%',
                        //createStyle['tooltip']
                    }}
                >
                    Save action
                </span>

                {/* {connectedDevice === 'Humanoid' && (
                    <img
                        className={createStyle['create-upload']}
                        style={{
                            cursor:
                                display == 'none' ? 'not-allowed' : 'pointer',
                            opacity: display == 'none' ? '0.5' : '1',
                        }}
                        src={renderPrgImage('uploadBtn')}
                        onClick={() => {
                            if (webSerial.isConnected) {
                                setDisplay('none')
                                worker.postMessage({
                                    type: 'fetchFileWriteArray',
                                    value: [
                                        'S'.charCodeAt(0),
                                        'R'.charCodeAt(0),
                                    ],
                                })
                                setTimeout(() => setDisplay('block'), 3000)
                            }
                        }}
                    />
                )} */}
                {/* <span
                    className={`${createStyle.tooltip} ${createStyle.readbtn}`}
                    style={{ position: 'absolute', right: '11%', bottom: '9%' }}
                >
                    Read servo
                </span> */}

                <img
                    className={createStyle['create-playgroup']}
                    style={{
                        pointerEvents:
                            display == 'none' &&
                            !['1', '2'].includes(deviceVersion[0])
                                ? 'none'
                                : 'auto',
                        opacity:
                            display == 'none' &&
                            !['1', '2'].includes(deviceVersion[0])
                                ? '0.5'
                                : '1',
                    }}
                    src={
                        display == 'none' &&
                        ['1', '2'].includes(deviceVersion[0])
                            ? renderPrgImage('pauseBtn')
                            : renderPrgImage('playrunBtn')
                    } //
                    onClick={handlePlayActionGroup}
                />
                <span
                    className={`${createStyle.tooltip} ${createStyle.groupPlaydbtn}`}
                    style={{
                        position: 'absolute',
                        right: '3%',
                        bottom: '9%',
                    }}
                >
                    play actions group
                </span>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return state
}
export default connect(mapStateToProps)(CreateAction)
